import {
  postersFetchAPoster,
  postersIsThereMorePosters,
  postersGetMargin,  
  postersGetPosterResposiveWidth,
  getPostersMaximumImageWidth,
  postersSetPosterResposiveWidth,
  postersApplyPosterImageAspectRatio,
  postersResetResolve,
  postersSetPostersIndexAndCursor,
  postersSetPostersFilter,
  postersSetRegionTownFilter,
  postersGetPostersIndex,
  posterGetCursorByAbsoluteIndex
} from "./posters.js";

import { posterCreateAndAppend } from "./poster.js";

import { browserGetBrowserWidth, browserImageIsReady } from "./browser.js";
import { adsenseAddAndPush, ADSENSE_MAXIMUM_WIDTH } from "./adsense.js";
import { controlSentinelIsVisible, controlSetCallback } from "./control.js";
import { analyticsPush } from "./analytics.js";

const PAGE_MINIMUM_POSTER_NUMBER = 5;
const PAGE_MAXIMUM_POSTER_NUMBER = 20;

let pageLines = 0;
let _pageCurrentLineWidth = 0;
let _pageHiddenPosterWrapper = null;
let _pagePostersNumber = 0;
let _pagePostersImagesNumber = 0;
// var pagePostersArray = [];
let pagePostersResolve;
let pagePostersReject;
let _pagePostersFilter;
let pageFetchNumber = 0;
let _pageNoPoster = false;

let _pageAdsNumber = 0;
let _pagePostersTown;
let _pagePostersRegion;

let _pageMinimumPostersNumber = PAGE_MINIMUM_POSTER_NUMBER;
let _pageMaximumPostersNumber = PAGE_MAXIMUM_POSTER_NUMBER;
let _pageEndingLine = false;

let _pageWrapper;
let _pageRequestId = 0;
let _pageSkipPoster;

function pagePxSizeToInt(css) {
  return parseInt(css.replace("px", ""));
}

function _pageResetLine() {
  _pageCurrentLineWidth = 0;
  _pageHiddenPosterWrapper = null;
  _pageEndingLine = false;
  _pageNoPoster = false;
}

function _pageResetState() {
  pageLines = 0;
  _pageResetLine();
  _pagePostersNumber = 0;
  _pagePostersImagesNumber = 0;
  pageFetchNumber = 0;
  _pageAdsNumber = 0;
  _pageMinimumPostersNumber = PAGE_MINIMUM_POSTER_NUMBER;
  _pageMaximumPostersNumber = PAGE_MAXIMUM_POSTER_NUMBER;
}

function pageIsNewLine(width) {
  // margins = 16 *4
  _pageCurrentLineWidth += width + postersGetMargin();

  // console.log("lineWidth ", _pageCurrentLineWidth);

  if (_pageCurrentLineWidth > browserGetBrowserWidth()) {
    pageLines++;
    _pageCurrentLineWidth = width + postersGetMargin();
    return true;
  }
  return false;
}

function pageFetch(pageElement, requestId) {
  postersFetchAPoster(null, null)
    .then((th) => {
      if (requestId !== _pageRequestId) {
        return;
      }
      pageFetchNumber++;
      if (th.poster !== null) {
        if (typeof _pageSkipPoster === "function" && _pageSkipPoster(th.poster)) {
          pageFetch(pageElement, requestId);
          return;
        }
        _pagePostersNumber++;
        //
        let wrapper = posterCreateAndAppend(th.poster, pageElement);
        let image = wrapper.getElementsByClassName("posterImage")[0];

        //
        // if it is endding the line no new ads
        if (_pagePostersNumber >= _pageMinimumPostersNumber === false) {
          if (Math.floor(_pagePostersNumber / 3) > _pageAdsNumber) {
            _pageAdsNumber++;
            adsenseAddAndPush(
              pageElement,
              postersGetPosterResposiveWidth(ADSENSE_MAXIMUM_WIDTH)
            );
          }
        }

        // this can be asynchronous ----------------------------------------
        browserImageIsReady(image, {
          resolveOnError: true,
          resolveOnTimeout: true,
          timeoutMs: 4500
        })
          .then(() => {
            let maximumImageWidth = getPostersMaximumImageWidth(
              image.naturalWidth,
              image.naturalHeight
            );
            postersApplyPosterImageAspectRatio(
              wrapper,
              image.naturalWidth,
              image.naturalHeight
            );
            postersSetPosterResposiveWidth(wrapper, maximumImageWidth);

            // Keep width assignment even if requestId changed meanwhile
            // (e.g. when secondary filtered list starts fetching).
            if (requestId !== _pageRequestId) {
              return;
            }
            _pagePostersImagesNumber++;

            //
            if (_pagePostersImagesNumber >= _pageMinimumPostersNumber) {
              if (controlSentinelIsVisible() === true) {
                if (pageFetchMorePosters(requestId) === true) {
                  return;
                }
              }

              // cal aquesta funcio??? o es priscndile
              if (pageAreAllImageWidthAvailable() === true) {
                if (pageIsLineFinished(wrapper, requestId) === false) {
                  pageFetch(pageElement, requestId);
                  return;
                }
              }

              if (_pageMinimumPostersNumber >= _pageMaximumPostersNumber) {
                pageFetchEnd(true, requestId);
                return;
              }
            }
          })
          .catch((err) => {
            if (requestId === _pageRequestId) {
              pagePostersReject(err);
            }
          });
      } else {
        _pageNoPoster = true;
      }
      // Wait 5 fetches to return there are no all the posters asked
      if (
        pageFetchNumber >= _pageMinimumPostersNumber &&
        _pageNoPoster === true
      ) {
        pageFetchEnd(false, requestId);
      }
    })
    .catch((err) => {
      if (requestId === _pageRequestId) {
        pagePostersReject(err);
      }
    });
}

function pageAreAllImageWidthAvailable() {
  let auxItems = _pageWrapper.getElementsByClassName("mainItem");
  return [].every.call(auxItems, (item) => item.style.width !== "");
}

function pageIsLineFinished(wrapper, requestId) {
  if (_pageEndingLine === true) {
    if (pageIsNewLine(pagePxSizeToInt(wrapper.style.width)) === true) {
      _pageHiddenPosterWrapper = wrapper;
      wrapper.style.display = "none";
      controlSetCallback(() => pageFetchMorePosters(requestId));
      return true;
    }
  } else {
    // finishing the last line ---------------------------------
    let auxItems = _pageWrapper.getElementsByClassName("mainItem");
    [].forEach.call(auxItems, (item) => {
      pageIsNewLine(pagePxSizeToInt(item.style.width));
    });

    _pageEndingLine = true;
  }
  return false;
}

function pageFetchMorePosters(requestId = _pageRequestId) {
  if (requestId !== _pageRequestId) {
    return false;
  }
  if (_pageMinimumPostersNumber < _pageMaximumPostersNumber) {
    // reset ending line
    _pageCurrentLineWidth = 0;
    _pageEndingLine = false;

    //
    if (_pageHiddenPosterWrapper !== null) {
      // hideen poster has been already contabilised
      _pageHiddenPosterWrapper.style.display = "block";
      _pageHiddenPosterWrapper = null;
    }

    _pageMinimumPostersNumber = _pagePostersNumber;

    // at least one more
    let newPageFetch = 0;
    do {
      pageFetch(_pageWrapper, requestId);
      _pageMinimumPostersNumber++;
      newPageFetch++;
      if (newPageFetch === 4) break;
    } while (_pageMinimumPostersNumber < _pageMaximumPostersNumber);

    analyticsPush("event", _pageMinimumPostersNumber.toString(), {
      event_category: "Posters Number"
    });

    return true;
  }
  return false;
}

function pageFetchEnd(final, requestId = _pageRequestId) {
  if (requestId !== _pageRequestId) {
    return;
  }
  if (_pageAdsNumber === 0) {
    let ads = document.getElementsByClassName("mainAdWrapper");
    if (ads.length > 0) {
      adsenseAddAndPush(ads[0]);
      _pageAdsNumber++;
    }
  }
  pagePostersResolve(final);
}

function pageFetchPosters(
  wrapper,
  region,
  town,
  label,
  index,
  cursor = "",
  regionParam = null,
  options = {}
) {
  _pageRequestId++;
  const requestId = _pageRequestId;
  postersResetResolve();
  _pageResetState();
  if (
    options &&
    Number.isInteger(options.targetPostersNumber) &&
    options.targetPostersNumber >= PAGE_MINIMUM_POSTER_NUMBER
  ) {
    _pageMaximumPostersNumber = options.targetPostersNumber;
  }
  postersSetPostersIndexAndCursor(index, cursor);
  postersSetPostersFilter(label);
  postersSetRegionTownFilter(region, town);
  _pagePostersFilter = label;
  _pagePostersRegion = typeof regionParam === "string" ? regionParam : "";
  _pagePostersTown = town;
  _pageSkipPoster = typeof options.skipPoster === "function" ? options.skipPoster : null;
  //
  window.addEventListener("resize", function (event) {
    let auxPosters = document.getElementsByClassName("mainItem");
    [].forEach.call(auxPosters, (poster) => {
      let auxImages = poster.getElementsByClassName("posterImage");
      let width;
      if (auxImages.length !== 0) {
        postersApplyPosterImageAspectRatio(
          poster,
          auxImages[0].naturalWidth,
          auxImages[0].naturalHeight
        );
        width = getPostersMaximumImageWidth(
          auxImages[0].naturalWidth,
          auxImages[0].naturalHeight
        );
      } else {
        width = ADSENSE_MAXIMUM_WIDTH;
      }
      postersSetPosterResposiveWidth(poster, width);
    });
  });
  //
  return new Promise(function (resolve, reject) {
    pagePostersResolve = resolve;
    pagePostersReject = reject;
    _pageWrapper = wrapper;
    // fetches 5 posters and ends the line
    pageFetch(wrapper, requestId);
    pageFetch(wrapper, requestId);
    pageFetch(wrapper, requestId);
    pageFetch(wrapper, requestId);
    pageFetch(wrapper, requestId);
  });
}

function pageIsThereMorePosters() {
  if (
    _pageHiddenPosterWrapper !== null ||
    postersIsThereMorePosters() === true
  ) {
    return true;
  }
  return false;
}

function pageGetNextPageHref(indexParamName = "index", includeCursor = true, cursorParamName = "cursor") {
  let currentIndex = pageGetNextPageIndex();
  let basePath = window.location.pathname || "/";
  if (basePath === "") {
    basePath = "/";
  }

  let params = new URLSearchParams(window.location.search || "");
  params.set("v", process.env.APP_VERSION);
  params.set(indexParamName, currentIndex);

  if (_pagePostersFilter !== "") params.set("label", _pagePostersFilter);
  if (_pagePostersTown !== "") params.set("town", _pagePostersTown);
  if (_pagePostersRegion !== "") params.set("region", _pagePostersRegion);

  if (includeCursor) {
    let cursor = posterGetCursorByAbsoluteIndex(currentIndex);
    if (cursor !== null) {
      params.set(cursorParamName, cursor);
    } else {
      params.delete(cursorParamName);
    }
  } else {
    params.delete(cursorParamName);
  }

  let query = params.toString();
  if (query !== "") {
    return `${basePath}?${query}`;
  }
  return basePath;
}

function pageGetNextPageIndex() {
  let currentIndex = postersGetPostersIndex();
  if (_pageHiddenPosterWrapper !== null) {
    currentIndex--;
  }
  return currentIndex;
}

function pageGetPostersNumber() {
  return _pagePostersNumber;
}

export {
  pageGetPostersNumber,
  pageFetchPosters,
  pageIsThereMorePosters,
  pageGetNextPageHref,
  pageGetNextPageIndex,
  pagePxSizeToInt
};
